import React from 'react';

import Icon from 'components/shared/Icon';
import Lock from 'components/shared/Icon/icons/Lock';

import Button from '../../../../../shared/Button';
import FormTitle from '../../../../../shared/Typography/FormTitle';
import Text from '../../../../../shared/Typography/Text';
import { useGuestFormBlockedOverlay } from './functions';
import s from './index.module.css';

const GuestFormBlockedOverlay = () => {
  const { isAccountOwner, handleButtonClick } = useGuestFormBlockedOverlay();

  const getNoteContent = () => {
    if (isAccountOwner) {
      return (
        <>
          <p>Please go to settings and submit your</p>
          <p>Privacy Policy to be able to use this feature.</p>
        </>
      );
    }
    return (
      <>
        <p>Please contact your Account Admin to submit the</p>
        <p>Privacy Policy to be able to use this feature</p>
      </>
    );
  };

  return (
    <div className={s.guestFormBlockedOverlay}>
      <div className={s.guestFormBlockedOverlayContent}>
        <div className={s.iconWrapper}>
          <Icon component={Lock} width="3rem" height="3rem" />
        </div>
        <FormTitle noBorder>Guest Forms Locked!</FormTitle>
        <Text accent className={s.message}>
          {getNoteContent()}
        </Text>
        {isAccountOwner && (
          <div className={s.buttonWrapper}>
            <Button htmlType="button" onClick={handleButtonClick}>
              Open Settings
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GuestFormBlockedOverlay;
